module.exports = __webpack_public_path__ + "img/icon-p-500.7854a210.png";